import * as Types from "../types";

const initialState = {
  wallet: {
    bill: null,
    check: false,
  },
};

function appReducer(state = initialState, action) {
  switch (action.type) {
    case Types.CONFIRM_WALLET: {
      return { ...state, wallet: { bill: action.payload.bill, check: false } };
    }
    case Types.CHECK_WALLET: {
      return { ...state, wallet: { bill: action.payload.bill, check: true } };
    }
    case Types.EXIT_WALLET: {
      return { ...state, wallet: { bill: null, check: false } };
    }
    default: {
      return state;
    }
  }
}

export default appReducer;
